/*
	Author: xowei <wei@xowei.tw>
	Website: https://xowei.tw/
*/

$(function () {
	var $body = $('body, html')
	var $gototop = $('.hud--gototop')
	var $preload = $('.preload')
	var $window = $(window)
	var windowScroll = 0

	$gototop.hide()

	$window.on('scroll', function () {
		windowScroll = $(window).scrollTop()

		if (windowScroll < window.innerHeight) {
			if ($gototop.length) $gototop.hide()
		} else {
			if ($gototop.length) $gototop.show()
		}
	})

	$(window).load(function () {
		$preload.fadeOut()
		initAnimate()
	})

	smoothScroll('a[href^="#"]')
	smoothScroll('#gototop')
	initNavbarCollapse()
	initDetectDevice()
	initNav()
	initCarousel()
	initHashLink()
	initModal()
	initScheduleScroll()
	initIntroduceModalOpen()
	initKVanimate()
})

function smoothScroll(target) {
	var $body = $('body, html')
	var $linkPosition
	var $nav = $('nav')

	$(target).each(function () {
		var $link = $(this)
		$linkPosition

		$link.on('click', function (e) {
			e.preventDefault()
			var tab = $link.attr('role')

			if (!tab) {
				var _href = $(this).attr('href')
				var $target = $(_href)
				$iconHeight = $('.product-title .icon').height()
				$linkPosition = ($target.length ? $target.offset().top : 0) - $nav.height()

				if ($target.is(':not(":first-child")')) {
					$linkPosition -= $iconHeight / 2
				}

				if (_href === '#kv') {
					history.pushState('', document.title, window.location.pathname + window.location.search)
				}

				$body.animate({
					scrollTop: $linkPosition,
				})
			}
		})
	})
}

function initKVanimate() {
	// 建立主要時間軸
	const tl = gsap.timeline();

	// 初始狀態設定：從畫面外放大淡入
	gsap.set('#kv .d-lg-block .left', {
		scale: 1.5,
		rotation: -10,
		x: 10,
		opacity: 0,
	});

	gsap.set('#kv .d-lg-block .right', {
		scale: 1.5,
		rotation: 10,
		opacity: 0,
	});

	gsap.set('#kv .center', {
		scale: 1.5,
		rotation: 0,
		opacity: 0,
	});

	const card_in = gsap.timeline();

	// 進場動畫（兩側同步淡入縮放）
	card_in
		.to(['#kv .d-lg-block .left'], {
			rotationY: 20,
			rotationZ: -8,
			scale: 1,
			transformOrigin: 'center center',
			opacity: 1,
			duration: 2,
			ease: 'power4.out',
		}, 0)

		.to(['#kv .d-lg-block .right'], {
			rotationY: -20,
			rotationZ: 8,
			scale: 1,
			transformOrigin: 'center center',
			opacity: 1,
			duration: 2,
			ease: 'power4.out',
		}, 0)

		.to(['#kv .center'], {
			scale: 1,
			transformOrigin: 'center center',
			opacity: 1,
			duration: 2,
			ease: 'power4.out',
		}, 0)

	tl.add(card_in, '+=0');
	
	// 輕微跳動效果（上下浮動）
	tl.to(['#kv .left', '#kv .right', '#kv .center'], {
		y: -10,
		duration: 0.2,
		yoyo: true,
		repeat: 1,
		ease: 'power1.inOut',
	});

	// 發光效果 timeline（同時執行不同濾鏡動畫）
	const glow = gsap.timeline();

	glow.to('#kv .kv-card-wrap-blue', {
		filter: 'drop-shadow(0 0 20px #3289ff)',
		duration: 0.3,
		repeat: 2,
		yoyo: true,
	}, 0); // 0 表示從 glow 開始立即執行

	glow.to('#kv .kv-card-wrap-red', {
		filter: 'drop-shadow(0 0 20px #ff3232)',
		duration: 0.3,
		repeat: 2,
		yoyo: true,
	}, 0);

	// 將發光效果加入主 timeline，接續執行
	tl.add(glow, '+=0');

	
	// 卡片浮動效果
	const box_floating = gsap.timeline();

	box_floating
		.to(['#kv .left .kv-card-box'],
		{
			x: -5,
			y: -5,
			transformOrigin: 'center center',
			duration: 2,
			yoyo: true,
			repeat: -1,
			ease: 'power4.out',
		})
		.to(['#kv .right .kv-card-box'],
		{
			x: 5,
			y: 5,
			transformOrigin: 'center center',
			duration: 2,
			yoyo: true,
			repeat: -1,
			ease: 'power4.out',
		})
		.to(['#kv .center .kv-card-box'],
		{
			x: -5,
			y: -5,
			transformOrigin: 'center center',
			duration: 2,
			yoyo: true,
			repeat: -1,
			ease: 'power4.out',
		})

	tl.add(box_floating, '+=0');
}

function initAnimate() {
	$('.section-title, .section-tt').attr('data-aos', function (i, v) {
		return v || 'zoom-in'
	})
	$('.section-carousel-text').attr('data-aos', 'fade-up')
	$('.section-source').attr('data-aos', 'fade-in')
	AOS.init({
		duration: 1000,
		// once: true,
	})
}

function initDetectDevice() {
	var classNames = []
	if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) classNames.push('device-ios')
	if (navigator.userAgent.match(/android/i)) classNames.push('device-android')
	if (navigator.userAgent.match(/Firefox/i)) classNames.push('device-firefox')
	if (navigator.userAgent.match(/Edg/i)) classNames.push('device-edge')
	if (navigator.userAgent.match(/Chrome/i)) classNames.push('device-chrome')

	var html = document.getElementsByTagName('html')[0]

	if (classNames.length) classNames.push('on-device')
	if (html.classList) html.classList.add.apply(html.classList, classNames)
}

function initNav() {
	$('.navbar a[href^="#"]:not(".dropdown-toggle")').on('click', function () {
		window.location.hash = $(this).attr('href')
		if ($(window).width() < 992) {
			$('.navbar-toggler').click()
		}
	})

	const collapse = document.querySelector('.navbar-collapse')
	const options = { attributes: true }

	function callback(mutationList, observer) {
		mutationList.forEach(function (mutation) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				let showExist = $(mutation.target).hasClass('show')

				if ($(window).width() < 992) {
					if (showExist) {
						$('body').addClass('nav--open')
					} else {
						$('body').removeClass('nav--open')
					}
				}
			}
		})
	}

	if (!collapse) return

	const observer = new MutationObserver(callback)
	observer.observe(collapse, options)
}

function initCarousel() {
	$('.owl-carousel').each(function () {
		const _this = $(this)
		const options = _this.data('options')

		_this.owlCarousel({
			...options,
			navText: [`<img src="./images/icon/icon-arrow_left.png">`, `<img src="./images/icon/icon-arrow_right.png">`],
		})
	})
}

function initNavbarCollapse() {
	$('.navbar-toggler-icon.is-open').hide()

	$('.navbar-collapse').on('shown.bs.collapse', function () {
		$(this).parent().find('> .navbar-social').addClass('is-hide')
		$('.navbar-toggler-icon.is-collapse').hide()
		$('.navbar-toggler-icon.is-open').show()
	})

	$('.navbar-collapse').on('hidden.bs.collapse', function () {
		$(this).parent().find('> .navbar-social').removeClass('is-hide')
		$('.navbar-toggler-icon.is-collapse').show()
		$('.navbar-toggler-icon.is-open').hide()
	})
}

function initHashLink() {
	let navHeight = $('.navbar').height()
	let hash = location.hash

	if (!hash) return

	setTimeout(() => {
		window.scrollTo({ top: $(hash).offset().top - navHeight, behavior: 'instant' })
	}, 1000)
}

function initModal() {
	// externalLinkModal
	const _externalLink = $('.external-link')
	const _externalLinkModal = $('#externalLinkModal')
	const _confirmExternalLink = $('#confirmExternalLink')

	_confirmExternalLink.on('click', function () {
		_externalLinkModal.modal('hide')
	})

	_externalLink.each(function () {
		const link = $(this).attr('href')
		const target = $(this).attr('target')

		$(this).on('click', function (event) {
			event.preventDefault()

			_externalLinkModal.find('#confirmExternalLink').attr({
				href: link,
				target: target,
			})

			_externalLinkModal.modal('show')
		})
	})

	// videoModal
	const _videoLink = $('.video-link')
	const _videoModal = $('#videoModal')

	_videoLink.each(function () {
		const utils = new Utils()
		const youtubeID = utils.getYouTubeID($(this).attr('href'))

		$(this).attr({
			'data-bs-toggle': 'modal',
			'data-bs-target': '#videoModal',
		})

		$(this).on('click', function (event) {
			event.preventDefault()
			const _iframe = _videoModal.find('iframe')
			_iframe.attr('src', `https://www.youtube.com/embed/${youtubeID}?autoplay=1`)
		})
	})

	_videoModal.on('hidden.bs.modal', function () {
		$(this).find('iframe').attr('src', '')
	})

	// introduceModal
	const _introduce_modal = $('.introduce_modal')
	const _modalGototop = $('.modal-gototop')

	_introduce_modal.each(function () {
		const _scrollTarget = $(this).find('.modal-body')
		const _gototop = $(this).find('.modal-gototop')

		_gototop.hide()

		_scrollTarget.on('scroll', function (event) {
			const modalScroll = $(this).scrollTop()

			if (modalScroll < event.currentTarget.clientHeight) {
				if (_gototop.length) _gototop.hide()
			} else {
				if (_gototop.length) _gototop.show()
			}
		})
	})

	_modalGototop.each(function () {
		$(this).on('click', function () {
			const _target = $(this).data('target')
			const _scrollTarget = $(`#${_target}`).find('.modal-body')

			_scrollTarget.animate({
				scrollTop: 0,
			})
		})
	})
}

function initScheduleScroll() {
	if (!$('.schedule').length) return
	$('.schedule')
		.find('.body')
		.on('scroll', function (event) {
			const endOfScroll = parseInt(event.currentTarget.offsetWidth - event.currentTarget.scrollLeft) < 20
			const _img = $(this).parent('.body-wrapper').find('.scroll img')
			if (endOfScroll) {
				_img.attr('src', './images/icon/icon_scroll-bottom.png')
			} else {
				_img.attr('src', './images/icon/icon_scroll-down.png')
			}
		})
}

function initIntroduceModalOpen() {
	let filename = window.location.pathname.split('/')?.pop().split('.')[0]
	if (filename !== 'introduce') return
	let params = new URLSearchParams(window.location.search)
	let pValue = params.get('p')

	const target = document.getElementById(`introduceModal_${pValue}`)
	if (!target) return
	const targetModal = new bootstrap.Modal(target)
	targetModal.show()
}

function Utils() {}

Utils.prototype = {
	constructor: Utils,
	isElementInView: function (element, fullyInView) {
		var pageTop = $(window).scrollTop()
		var pageBottom = pageTop + $(window).height()
		var elementTop = $(element).offset().top
		var elementBottom = elementTop + $(element).height()

		if (fullyInView === true) {
			return pageTop < elementTop && pageBottom > elementBottom
		} else {
			return elementTop <= pageBottom && elementBottom >= pageTop
		}
	},
	smoothScroll: function () {
		$('a[href^="#"]').on('click', function (e) {
			var $target = $(e.currentTarget.hash)

			$('html,body').animate(
				{
					scrollTop: $target.offset().top,
				},
				700,
			)

			e.preventDefault()
		})
	},
	detectViewport: function () {
		return { height: window.innerHeight, width: window.innerWidth }
	},
	getYouTubeID: function (url) {
		const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:live\/|watch\?v=|embed\/|v\/))([\w-]{11})/)
		return match ? match[1] : ''
	},
}
